import * as React from 'react';
import { Button, FormGroup, Input, Label } from 'reactstrap';
import { useEffect, useState } from 'react';
import { Communicator } from '../../tools/Communication';
import { ResponsiveTable } from '../../components/Layout';
import { MultiSelect } from 'primereact/multiselect';

export default function EditMerchantOrderConfigPage() {
  const key = 'MerchantOrderConfig';
  const [config, setConfig] = useState({
    Regions: [],
    Cities: [],
  } as {
    Regions: { Id: number; SlackUrl: string }[];
    Cities: string[];
  });
  const [regions, setRegions] = useState([] as { id: number; name: string }[]);
  const [cities, setCities] = useState(
    [] as { label: string; value: string }[],
  );
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    Communicator.Get('/Config/GetConfigValue', { key })
      .then((response) => response.json())
      .then((config) => setConfig(config));
    Communicator.Get('/Merchant/GetRegions', {}).then(async (response) => {
      const regionData = (await response.json()) as any[];
      setRegions(regionData);
    });
    Communicator.Get('/Merchant/GetCities', {}).then(async (response) => {
      const cities = (await response.json()) as any[];
      setCities(
        cities.map((c) => {
          return { label: c.name, value: c.id };
        }),
      );
    });
  }, []);

  async function saveConfig() {
    setIsLoading(true);
    try {
      console.log({ config: config });
      const result = await Communicator.PostData('/Config/SetConfigValue', {
        Key: 'MerchantOrderConfig',
        Value: JSON.stringify(config),
      });
      setConfig(await result.json());
    } catch (e) {
      alert('Error saving config');
    }
    setIsLoading(false);
  }

  function setSlackUrl(regionId: number, slackUrl: string) {
    setConfig((oldConfig) => {
      const config = { ...oldConfig };
      let index = config.Regions.findIndex((c) => c.Id === regionId);
      if (index === -1) {
        index = config.Regions.push({ Id: regionId, SlackUrl: '' }) - 1;
      }
      config.Regions[index].SlackUrl = slackUrl;
      return config;
    });
  }

  function setConfigCities(cities: string[]) {
    setConfig((oldConfig) => {
      const config = { ...oldConfig };
      config.Cities = cities;
      return config;
    });
  }

  return (
    <div>
      <h4>Local ops slack urls</h4>
      <ResponsiveTable>
        <thead>
          <tr>
            <th>Region</th>
            <th>Slack url</th>
          </tr>
        </thead>
        <tbody>
          {[...regions]
            .sort((a, b) => a.id - b.id)
            .map((r) => {
              return (
                <tr key={r.id}>
                  <td>{r.name}</td>
                  <td>
                    <div className="input-group">
                      <input
                        value={
                          (
                            config.Regions.find((c) => c.Id === r.id) || {
                              SlackUrl: '',
                            }
                          ).SlackUrl
                        }
                        type="text"
                        className="form-control"
                        onChange={(e) => setSlackUrl(r.id, e.target.value)}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </ResponsiveTable>
      <br />
      <div className="input-group mb-3">
        <span className="input-group-text" id="basic-addon1">
          Key Cities
        </span>
        <MultiSelect
          value={config.Cities}
          options={cities || []}
          onChange={(e) => setConfigCities(e.target.value)}
        />
      </div>

      <Button
        style={{ margin: '0.5em' }}
        color="primary"
        size="sm"
        onClick={saveConfig}
      >
        {isLoading ? 'Saving...' : 'Save'}
      </Button>
    </div>
  );
}
